import React, {Component} from 'react';

class SubscriptionInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    };

    render() {

        if( typeof this.props.data.selling_plan_allocation === "undefined" ) return null;
        if( typeof this.props.data.selling_plan_allocation.selling_plan === "undefined" ) return null;

        return (
            <React.Fragment>
                <div className="property">
                    <span>{this.props.data.selling_plan_allocation.selling_plan.name}</span>
                </div>
            </React.Fragment>
        )
    };
}

export default SubscriptionInfo;